
// Covers youtube.com/watch?v=ID, youtube.com/shorts/ID, youtube.com/embed/ID,
// and youtu.be/ID. Shorts/embed URLs carry the id in the path, not a `v`
// query param, so a plain searchParams.get('v') lookup misses them.
const extractYoutubeId = (url) => {
  if (!url) return null;
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]+)/
  );
  return match ? match[1] : null;
};

export const getYoutubeEmbedUrl = (url) => {
  const youtubeId = extractYoutubeId(url);
  return youtubeId ? `https://www.youtube.com/embed/${youtubeId}` : undefined;
}

export const getYoutubeThumbnail = (url) => {
  const youtubeId = extractYoutubeId(url);
  return youtubeId ? `https://img.youtube.com/vi/${youtubeId}/0.jpg` : undefined;
}

